module.exports = __webpack_public_path__ + "static/Teammates-ClickUp-46e9ec2bc11a2c619bd68c4abb996173.png";